import React from "react";

const TetherTRCIcon = ({ className }) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    overflow="visible"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(16 17) scale(1.7) translate(-16 -16)">
      <path
        d="M9.97961 7.3335H22.2674C22.5606 7.3335 22.8314 7.48543 22.9777 7.73191L26.5577 13.7666C26.7432 14.0795 26.6882 14.4745 26.4233 14.7283L16.5694 24.1718C16.2502 24.4777 15.7367 24.4777 15.4175 24.1718L5.57701 14.7411C5.30605 14.4814 5.25531 14.0749 5.45456 13.76L9.28122 7.71255C9.43026 7.47703 9.69472 7.3335 9.97961 7.3335Z"
        fill="#69AC96"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6808 10.0278V11.721H17.1805V12.895C19.6389 13.0204 21.4833 13.5357 21.497 14.1533L21.4969 15.4408C21.4832 16.0584 19.6389 16.5737 17.1805 16.6991V19.5802H14.8563V16.6991C12.3979 16.5737 10.5535 16.0584 10.5398 15.4408L10.5399 14.1533C10.5536 13.5357 12.3979 13.0204 14.8563 12.895V11.721H11.356V10.0278H20.6808ZM16.0184 15.8146C18.6419 15.8146 20.8347 15.3789 21.3714 14.797C20.9163 14.3036 19.2703 13.9153 17.1805 13.8087V15.0378C16.806 15.0569 16.4172 15.067 16.0184 15.067C15.6196 15.067 15.2308 15.0569 14.8563 15.0378V13.8087C12.7666 13.9153 11.1205 14.3036 10.6654 14.797C11.2021 15.3789 13.3949 15.8146 16.0184 15.8146Z"
        fill="white"
      />
    </g>

    <g
      transform="translate(1 -3)"
      clipPath="url(#clip0_1364_7343)"
    >
      <path
        d="M27 36C31.9706 36 36 31.9706 36 27C36 22.0294 31.9706 18 27 18C22.0294 18 18 22.0294 18 27C18 31.9706 22.0294 36 27 36Z"
        fill="#EF0027"
      />

      <path
        d="M30.3367 23.576L22.2188 22.082L26.4909 32.8325L32.4439 25.5797L30.3367 23.576ZM30.2062 24.2342L31.4482 25.4148L28.0519 26.0297L30.2062 24.2342ZM27.3139 25.9065L23.7341 22.9376L29.5852 24.0142L27.3139 25.9065ZM27.0591 26.4318L26.4752 31.2581L23.328 23.3364L27.0591 26.4313V26.4318ZM27.5991 26.6878L31.3605 26.0072L27.0461 31.2626L27.5991 26.6878Z"
        fill="white"
      />
    </g>

    <defs>
      <clipPath id="clip0_1364_7343">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(18 18)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default TetherTRCIcon;
